module.exports = __webpack_public_path__ + "static/media/logo.ab8b4076.png";